"use strict";
const BaseAnalytics = require("../base/BaseAnalytics");

const {
    PAGE_LOAD
} = require("../models/Backup");

const {
    SIGN_UP
} = require("../models/SmsSignUp");

const SMS_SIGNUP_ACTION = "LEAD";

class BackupAnalytics extends BaseAnalytics {
    /**
     * This constructor sets the @property { string } this.file to be able to track which module may be throwing an error.
     *
     * @memberof BackupAnalytics
     */
    constructor() {
        super("BackupAnalytics", PAGE_LOAD);
    }

    /**
     * Initializing the class with collect(), engages all analytics listeners
     *
     * @memberof BackupAnalytics
     */
    collect() {
        this.pageInterceptedEvents();
    }

    /**
    * Handles page events for SMS analytics.
    * This function is intended to be a placeholder for managing various page events
    * related to SMS analytics. It currently does not implement any functionality.
    * Future implementations may include event listeners or handlers for specific
    * page interactions that are relevant to SMS analytics tracking.
    */
    pageEvents() {
    }

    /**
    * Sets up an event listener for window messages to intercept specific page events related to SMS sign-up.
    * When a message is received, it checks if the message contains data with an action matching the SMS sign-up action
    * and a phone number. If these conditions are met, it triggers the preparation of a single sign-up event.
    */
    pageInterceptedEvents() {
        this.initializeSmsModalSignUpEvent();
    }

    /**
    * Initializes the SMS modal sign-up event listener.
    * This function sets up a message event listener on the window object to handle
    * incoming messages. When a message with the specified action and a phone number
    * is received, it triggers the preparation of a single event for SMS sign-up.
    */
    initializeSmsModalSignUpEvent() {
        window.onmessage = (params) => {
            if ("data" in params) {
                try {
                    const data = params.data;

                    if (typeof data !== "object" || !data.__attentive) return;

                    if (data.__attentive.action === SMS_SIGNUP_ACTION && data.__attentive.phone) {
                        this.prepareSingleEvent(SIGN_UP, {});
                    }
                } catch (error) {
                    //do nothing
                }
            }
        };
    }

    /**
    * Handles delayed events on the page.
    * This function is intended to manage events that should be triggered
    * after a certain delay or under specific conditions on the page.
    * Currently, the implementation is empty and needs to be defined
    * based on the specific requirements of the delayed events.
    */
    pageDelayedEvents() {
    }
}

module.exports = BackupAnalytics;
